/**
 * 检测浏览器版本
 * @returns {object} 浏览器信息，包含name和version
 */
export function detectBrowser() {
  const userAgent = navigator.userAgent;
  let browser = {
    name: '',
    version: 0,
  };

  // 检测Chrome
  const chromeMatch = userAgent.match(/Chrome\/(\d+)/);
  if (chromeMatch) {
    browser.name = 'Chrome';
    browser.version = parseInt(chromeMatch[1], 10);
    return browser;
  }

  // 检测Edge (基于Chromium)
  const edgeMatch = userAgent.match(/Edg\/(\d+)/);
  if (edgeMatch) {
    browser.name = 'Edge';
    browser.version = parseInt(edgeMatch[1], 10);
    return browser;
  }

  // 检测Firefox
  const firefoxMatch = userAgent.match(/Firefox\/(\d+)/);
  if (firefoxMatch) {
    browser.name = 'Firefox';
    browser.version = parseInt(firefoxMatch[1], 10);
    return browser;
  }

  // 检测Safari
  const safariMatch = userAgent.match(/Version\/(\d+).*Safari/);
  if (safariMatch) {
    browser.name = 'Safari';
    browser.version = parseInt(safariMatch[1], 10);
    return browser;
  }

  return browser;
}

/**
 * 将Chrome版本号映射到其他浏览器的等效版本
 * @param {number} chromeVersion Chrome版本号
 * @param {string} targetBrowser 目标浏览器
 * @returns {number} 等效版本号
 */
function mapChromeVersion(chromeVersion: number, targetBrowser: string): number {
  // 版本映射关系
  const versionMappings = {
    Firefox: (chromeVersion: number) => Math.max(97, chromeVersion - 3), // Firefox版本通常比Chrome低3个版本
    Safari: (chromeVersion: number) => Math.max(15, Math.floor(chromeVersion / 6.67)), // Safari版本号增长较慢
  };

  const mapper = versionMappings[targetBrowser as keyof typeof versionMappings];
  return mapper ? mapper(chromeVersion) : chromeVersion;
}

/**
 * 检查浏览器是否满足最低版本要求
 * @param {number} minVersion 最低版本要求（基于Chrome版本）
 * @returns {boolean} 是否满足要求
 */
export function isBrowserCompatible(minVersion: number) {
  const browser = detectBrowser();

  // Chrome, Edge (基于Chromium) 直接比较版本号
  if (browser.name === 'Chrome' || browser.name === 'Edge') {
    return browser.version >= minVersion;
  }

  // 对于Firefox和Safari，根据Chrome版本进行映射
  if (browser.name === 'Firefox' || browser.name === 'Safari') {
    const mappedVersion = mapChromeVersion(minVersion, browser.name);
    return browser.version >= mappedVersion;
  }

  // 未知浏览器或无法检测，默认不兼容
  return false;
}
